import { Badge } from '@/components/ui/badge';
import { CheckCircle, XCircle, Clock, AlertCircle } from 'lucide-react';

interface ApprovalStatusProps {
  status: string;
  className?: string;
}

export function ApprovalStatus({ status, className }: ApprovalStatusProps) {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'APPROVED':
        return {
          label: 'Aprovado',
          icon: CheckCircle,
          className: 'bg-green-100 text-green-800 border-green-200',
          iconColor: 'text-green-600'
        };
      case 'REJECTED':
        return {
          label: 'Rejeitado',
          icon: XCircle,
          className: 'bg-red-100 text-red-800 border-red-200',
          iconColor: 'text-red-600'
        };
      case 'PENDING':
        return {
          label: 'Pendente',
          icon: Clock,
          className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
          iconColor: 'text-yellow-600'
        };
      case 'CANCELLED':
        return {
          label: 'Cancelado',
          icon: AlertCircle,
          className: 'bg-gray-100 text-gray-800 border-gray-200',
          iconColor: 'text-gray-600'
        };
      default:
        return {
          label: status,
          icon: AlertCircle,
          className: 'bg-gray-100 text-gray-800 border-gray-200',
          iconColor: 'text-gray-600'
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Badge variant="outline" className={`pl-1 pr-2 py-1 flex items-center gap-1 ${config.className}`}>
        <Icon className={`w-3 h-3 ${config.iconColor}`} />
        <span>{config.label}</span>
      </Badge>
    </div>
  );
}
